if($('.product-page').length > 0) {

    window.filterShopaholicAjaxRequest = () => {

        $.request('OfferListHelper::onAjaxRequest', {
            data: {
                date: $('.oc-filter-shopaholic._calendar-data ._start-date input').val(),
                period: $('.oc-filter-shopaholic._calendar-data ._period input').val()
            },
            loading: '.js-preloaderOverlay',
            update: {
                'offer_list': 'table.product-offers',
                'product_pagination_button': '.oc-shopaholic-pagination',
                'product_offer_count': '.product-description__purchase .btn'
            }
        });
    };

    window.sortingShopaholicAjaxRequest = () => {

        $.request('OfferListHelper::onAjaxRequest', {
            loading: '.js-preloaderOverlay',
            update: {
                'offer_list': 'table.product-offers',
                'product_pagination_button': '.oc-shopaholic-pagination'
            }
        });
    };

    window.paginationShopaholicAjaxRequest = (_this) => {
        
        $.request('OfferListHelper::onAjaxRequest', {
            loading: '.js-preloaderOverlay',
            update: {
                'offer_list': 'table.product-offers',
                'product_pagination_button': '.oc-shopaholic-pagination'
            }
        });
    };
}


// WEBPACK FOOTER //
// ./src/pages/product/product.js